import MuiDialog from '@mui/material/Dialog';
import SlideTransition from '@/components/SlideTransition';
import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import MuiListItemButton from '@mui/material/ListItemButton';
import { type ShortcutKey } from '@/constants/shortcutKeys';
import { classes, type ShortcutOption, SHORTCUTS } from './utils';

export type ShortcutsDialogProps = {
  onSelect: (shortcut: ShortcutKey) => void;
  onClose: () => void;
};

export default function ShortcutsDialog({
  onSelect,
  onClose,
}: ShortcutsDialogProps) {
  const renderListItem = ({ name, shortcut }: ShortcutOption) => {
    return (
      <MuiListItem key={name} disablePadding>
        <MuiListItemButton
          className={classes.listItemButton}
          onClick={() => onSelect(shortcut)}>
          <div className={classes.shortcut}>{shortcut}</div>
          <div className={classes.name}>{name}</div>
        </MuiListItemButton>
      </MuiListItem>
    );
  };

  return (
    <MuiDialog
      open
      keepMounted
      maxWidth={false}
      TransitionComponent={SlideTransition}
      PaperProps={{
        className: classes.paper,
      }}
      onClose={onClose}>
      <div className={classes.listWrapper}>
        <MuiList className={classes.list}>
          {SHORTCUTS.map(renderListItem)}
        </MuiList>
      </div>
    </MuiDialog>
  );
}
